import { render, staticRenderFns } from "./StockUpStoreOrder.vue?vue&type=template&id=37dba4dc&scoped=true"
import script from "./StockUpStoreOrder.vue?vue&type=script&lang=js"
export * from "./StockUpStoreOrder.vue?vue&type=script&lang=js"
import style0 from "./StockUpStoreOrder.vue?vue&type=style&index=0&id=37dba4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dba4dc",
  null
  
)

export default component.exports